/**
 * testId 派生规则（统一，A/C 阶段一致）
 *
 * 规范：{formId}.{fieldKey}，fieldKey = formItemKeyToList(formItemKey).join('.')
 * - A 阶段用 SForm formItemKey，C 阶段用 bedrock Form.Item.name，格式一致 → 消费方选择器不变。
 * - formItemKeyMap 场景：用聚合 formItemKey（SFormItem/index.tsx:135 解构的，如 $validity）派生 testId，
 *   保证一控件一 testId；FieldTestState 按字段名展开。对齐陷阱 #7/#8（清空用 null）。
 */

import { formItemKeyToList } from '../components/SForm/SFormItem/utils';

type NamePath = string | number | (string | number)[];

export const buildTestId = (formId: string, formItemKey: NamePath): string =>
  `${formId}.${formItemKeyToList(formItemKey).join('.')}`;
